import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux'
import Icon from './icon/icon.jsx';
import * as S from './rateCompStyled.style.js';
import CommonStyle from './common.style';
import { submitFeedbackcall } from './../redux/thunks'
import { setter } from '@stencil/client-side-storage'
import { pushga } from 'ga-utils';
import { ThankyouPageEvents } from './../../../config/ga-config';
import { pushCtaOmniEvents } from '../../../utils/PushEvents/Omniture/clickEvents';
import { CTA_TYPE } from '../../../utils/PushEvents/Omniture/utils';

const RateCompStyled = (props) => {
  const dispatch = useDispatch();
  const [ratingApiCall, toggleRatingApiCall] = useState(false);
  const [selectOption, setSelectOption] = useState(-1);
  const [selectOption2, setSelectOption2] = useState(-1);
  const [showComponent, toggleComponent] = useState(true);
  const { thankyouInfo } = props;
  const { txnid } = thankyouInfo;
  const breakpoint = 620;

  const useViewport = () => {
    const [width, setWidth] = useState(window.innerWidth);
    useEffect(() => {
      const handleWindowResize = () => setWidth(window.innerWidth);
      window.addEventListener('resize', handleWindowResize);
      return () => window.removeEventListener('resize', handleWindowResize);
    }, []);
    return { width };
  };
  
  const { width } = useViewport();
  
  // console.log("selectOption", selectOption, "selectOption2", selectOption2)

  const sendFeedback = (redirect = false) => {
    // console.log("####### redirect: " + redirect, " selectOption2: " + selectOption2 + " ratingApiCall:"+ ratingApiCall);

    if(!ratingApiCall && selectOption2 > 0){
      toggleRatingApiCall(true);
      dispatch(submitFeedbackcall({ userRating: selectOption2, redirect: redirect }));
    }
  }

  const ctaEventCaller = (index) => {
    pushCtaOmniEvents(`Rated ${index} stars`, CTA_TYPE.IMAGES, 'Booking Experince Rating Bar', 'ThankyouPage');
  }

  const handleClose = (page) => {
    sendFeedback(false);
    // GA
    pushga({
      event: page,
      eventCategory: ThankyouPageEvents.eventCategory.closeScreen,
      eventLabel: page + '_' + ThankyouPageEvents.category
    });
    setSelectOption(-1);
    setSelectOption2(-1);
    toggleComponent(false);
  };

  const setSecondPageGAEvent = (index, eventType, action) => {
    const gaItem = {};
    if (index <= 3) {
      gaItem.event = ThankyouPageEvents.pages.tynps_givefeedback;
      gaItem.eventLabel = ThankyouPageEvents.pages.tynps_givefeedback + '_' + ThankyouPageEvents.category;
      (typeof action !== 'undefined') ? gaItem.eventAction = action : '';

      if (eventType === 'onload') {
        gaItem.eventCategory = ThankyouPageEvents.eventCategory.openScreen + '_' + ThankyouPageEvents.pages.tynps_givefeedback;
      } else if (eventType === 'click') {
        gaItem.eventCategory = ThankyouPageEvents.eventCategory.rating;
      } else {
        gaItem.eventCategory = ThankyouPageEvents.eventCategory.feedback;
      }
      pushga(gaItem);
    } else if (index > 3) {
      gaItem.event = ThankyouPageEvents.pages.tynps_45input;
      gaItem.eventLabel = ThankyouPageEvents.pages.tynps_45input + '_' + ThankyouPageEvents.category;
      (typeof action !== 'undefined') ? gaItem.eventAction = action : '';

      if (eventType === 'onload') {
        gaItem.eventCategory = ThankyouPageEvents.eventCategory.openScreen + '_' + ThankyouPageEvents.pages.tynps_45input;
      } else if (eventType === 'click') {
        gaItem.eventCategory = ThankyouPageEvents.eventCategory.rating;
      } else {
        gaItem.eventCategory = ThankyouPageEvents.eventCategory.feedback;
      }
      pushga(gaItem);
    }
  }

  const onFeedBackClick = () => {
    setter('bus_rating_shown', { [txnid]: true });
    setSecondPageGAEvent(selectOption, 'feedback', selectOption + 'star');
    sendFeedback(true);
  }

  if (showComponent) {
    // ga onLoad showComponent
    pushga({
      event: ThankyouPageEvents.pages.tynpsrating,
      eventCategory: ThankyouPageEvents.eventCategory.openScreen + '_' + ThankyouPageEvents.pages.tynpsrating,
      eventLabel: ThankyouPageEvents.pages.tynpsrating + '_' + ThankyouPageEvents.category
    });
  }

  const onStarClick = (index) => {
    setSelectOption(index)
    setSelectOption2(index)
  }

  useEffect(() => {
    if (selectOption2 > 0) {
      setSecondPageGAEvent(selectOption2, 'click', selectOption2 + 'star');

      const appDownloadCondition = width < breakpoint && selectOption > 3;
      if(appDownloadCondition){
        sendFeedback(false);
      }
    }
  }, [selectOption2])

  return (<>
    {showComponent ?
      <S.RateComp>
        <CommonStyle></CommonStyle>
        <S.RateTitle>
          Rate your booking experience!
          <div onClick={() => handleClose('tynpsrating')}>
            {width < breakpoint && <Icon spriteClass="sprite" iconClass="greyCross" />}
            {width > breakpoint && <Icon spriteClass="sprite" iconClass="greyCross--big" />}
          </div>
        </S.RateTitle>

        {width < breakpoint && <S.RateStar>
          {[...Array(5)].map((star, index) => {
            index += 1;
            return (
              <p key={index} onClick={() => {
                onStarClick(index);
                // GA rate on tynpsrating
                pushga({
                  event: ThankyouPageEvents.pages.tynpsrating,
                  eventCategory: ThankyouPageEvents.eventCategory.rating,
                  eventLabel: 'BUS_DOM',
                  eventAction: index + 'star'
                });
                ctaEventCaller(index);
              }
              }>
                {index <= selectOption ? (
                  <Icon spriteClass="sprite" iconClass="yellowStar"></Icon>
                ) : (
                  <Icon spriteClass="sprite" iconClass="blankStar"></Icon>
                )}
              </p>
            );
          })}
        </S.RateStar>}

        {width > breakpoint && <S.RateStar>
          {[...Array(5)].map((star, index) => {
            index += 1;
            return (
              <p key={index} onClick={() => {
                onStarClick(index);
                // GA on click rate
                pushga({
                  event: ThankyouPageEvents.pages.tynpsrating,
                  eventCategory: ThankyouPageEvents.eventCategory.rating,
                  eventLabel: ThankyouPageEvents.pages.tynpsrating + '_' + ThankyouPageEvents.category,
                  eventAction: index + 'star'
                });
                ctaEventCaller(index);
              }}>
                {index <= selectOption ? (
                  <Icon spriteClass="sprite" iconClass="yellowStar--big"></Icon>
                ) : (
                  <Icon spriteClass="sprite" iconClass="blankStar--big"></Icon>
                )}
              </p>
            );
          })}
        </S.RateStar>}

        {/* appDownloadCondition */}
        {width < breakpoint && selectOption > 3 && (
          <React.Fragment>
            <S.RatePlayStore>
              <div onClick={() => handleClose('tynps_45input')}>
                <Icon
                  spriteClass="sprite"
                  iconClass="blackCross"
                />
              </div>
              <S.RatePlayStoreImg>
                <img src="https://gos3.ibcdn.com/appreciate-1639045484.png" />
              </S.RatePlayStoreImg>
              <h5>Thanks for your appreciation!</h5>
              <p className="playStoreInfo">
                For more exciting offers &amp; deals download Goibibo app.
              </p>
              {/* <S.RateSubInfo>
                <Icon spriteClass="sprite" iconClass="smileyIcon" />
                <span> A 5 star rating would really make our day! </span>
              </S.RateSubInfo> */}
              <S.RateLinkBtn onClick={() => {
                window.location.href = 'https://go.ibi.bo/sOA2Fnk1flb';
              }}>
                {/* <Icon spriteClass="sprite" iconClass="playStoreIcon" /> */}
                Download App
              </S.RateLinkBtn>
            </S.RatePlayStore>
            <S.BackDrop onClick={() => handleClose('tynps_45input')}></S.BackDrop>
          </React.Fragment>
        )}

        {/* rateExperince */}
        {selectOption <= 3 && selectOption >= 0 && selectOption != null ? (width < breakpoint) ?
          (<React.Fragment>
            <S.RateFeedBack>
              <h5>Rate your booking experience!</h5>
              <S.RateStar>
                {[...Array(5)].map((star, index) => {
                  index += 1;
                  return (
                    <p key={index} onClick={() => {
                      onStarClick(index);
                      // GA
                      pushga({
                        event: ThankyouPageEvents.pages.tynpsrating,
                        eventCategory: ThankyouPageEvents.eventCategory.rating,
                        eventLabel: ThankyouPageEvents.pages.tynpsrating + '_' + ThankyouPageEvents.category,
                        eventAction: index + 'star'
                      });
                      ctaEventCaller(index);
                    }}>
                      {index <= selectOption2 ? (
                        <Icon
                          spriteClass="sprite"
                          iconClass="yellowStar"></Icon>
                      ) : (
                        <Icon spriteClass="sprite" iconClass="blankStar"></Icon>
                      )}
                    </p>
                  );
                })}
              </S.RateStar>
              <p className="feedBack">
                We are really sorry for bad experience. Please tell us more
                about this so that we can improve it
              </p>
              <S.RateLinks>
                <span onClick={() => handleClose('tynps_givefeedback')}>Not Now</span>
                <S.FeedBackBtn onClick={onFeedBackClick}>Give feedback</S.FeedBackBtn>
              </S.RateLinks>
            </S.RateFeedBack>
            <S.BackDrop onClick={() => handleClose('tynps_givefeedback')}></S.BackDrop>
          </React.Fragment>) : (
            <React.Fragment>
              <S.RateFeedBack>
                <div onClick={() => handleClose('tynps_givefeedback')}>
                  <Icon
                    spriteClass="sprite"
                    iconClass="greyCross--big"
                  />
                </div>
                <h5>Your feedback is important to us!</h5>
                <S.RateStar>
                  {[...Array(5)].map((star, index) => {
                    index += 1;
                    return (
                      <p key={index} onClick={() => { onStarClick(index); }}>
                        {index <= selectOption2 ? (
                          <Icon
                            spriteClass="sprite"
                            iconClass="yellowStar--big"></Icon>
                        ) : (
                          <Icon spriteClass="sprite" iconClass="blankStar--big"></Icon>
                        )}
                      </p>
                    );
                  })}
                </S.RateStar>
                <p className="feedBack">
                  We are really sorry for bad experience. Please tell us more<br />
                  about this so that we can improve it
                </p>
                <S.FeedBackBtn onClick={onFeedBackClick}>Give feedback</S.FeedBackBtn>
              </S.RateFeedBack>
              <S.BackDrop onClick={() => handleClose('tynps_givefeedback')}></S.BackDrop>
            </React.Fragment>
          ) : <></>}

        {/* sendFeedBack */}
        {width > breakpoint && selectOption > 3 && (
          <React.Fragment>
            <S.RateFeedBack>

              {(width > breakpoint) ?
                <div onClick={() => handleClose('tynps_45input')}>
                  <Icon
                    spriteClass="sprite"
                    iconClass="greyCross--big"
                  />
                </div> :
                <></>}

              <h5>Your input is valuable to us.</h5>
              <S.RateStar>
                {[...Array(5)].map((star, index) => {
                  index += 1;
                  return (
                    <p key={index} onClick={() => { onStarClick(index); }}>
                      {index <= selectOption2 ? (
                        <Icon
                          spriteClass="sprite"
                          iconClass="yellowStar--big"></Icon>
                      ) : (
                        <Icon spriteClass="sprite" iconClass="blankStar--big"></Icon>
                      )}
                    </p>
                  );
                })}
              </S.RateStar>
              <p className="feedBack">
                Please take a moment to share your feedback to make it a better<br /> experience for you. Thanks for your support!
              </p>

              {(width > breakpoint) ?
                <S.FeedBackBtn onClick={onFeedBackClick}>Give feedback</S.FeedBackBtn> :
                <S.RateLinks>
                  <span onClick={() => handleClose('tynps_45input')}>Not Now</span>
                  <S.FeedBackBtn onClick={onFeedBackClick}>Give feedback</S.FeedBackBtn>
                </S.RateLinks>}

            </S.RateFeedBack>
            <S.BackDrop onClick={() => handleClose('tynps_45input')}></S.BackDrop>
          </React.Fragment>
        )}
      </S.RateComp>
      : <></>
    }
  </>);
};

export default RateCompStyled;
